import { intlLocaleFromLocale } from 'wanderu-i18n';

async function polyfillIntlWithLocales(locales) {
    const intlImportFn = import('intl');
    await intlImportFn;

    for (let locale of locales) {
        const intlLocale = intlLocaleFromLocale(locale);
        const intlLocalePromise = import(`intl/locale-data/jsonp/${intlLocale}.js`);
        await intlLocalePromise;
    }
}

export default {
    polyfillIntlWithLocales,
};

export {
    polyfillIntlWithLocales,
};
